import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PROVIDERS } from './aiModels';

// Manual add for a model id the provider does not list yet. It is enabled
// at once; the label defaults to the id.
export default function AddAiModelForm({ busy, onAdd }) {
    const [provider, setProvider] = useState(PROVIDERS[0].value);
    const [modelId, setModelId] = useState('');
    const [label, setLabel] = useState('');

    const submit = async (e) => {
        e.preventDefault();
        const added = await onAdd({ provider, model_id: modelId.trim(), label: label.trim() || null });
        if (added) { setModelId(''); setLabel(''); }
    };

    return (
        <form className="st-add-form" onSubmit={submit}>
            <select className="st-select" aria-label="Provider" value={provider} onChange={e => setProvider(e.target.value)}>
                {PROVIDERS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
            </select>
            <input
                className="st-input st-mono"
                aria-label="Model id"
                placeholder="Model id, e.g. claude-opus-5"
                value={modelId}
                onChange={e => setModelId(e.target.value)}
                required
            />
            <input
                className="st-input"
                aria-label="Label"
                placeholder="Label (optional)"
                value={label}
                onChange={e => setLabel(e.target.value)}
            />
            <button type="submit" className="ne-btn" disabled={busy === 'add' || !modelId.trim()}>
                <i className="pi pi-plus" /> Add model
            </button>
        </form>
    );
}

AddAiModelForm.propTypes = {
    busy: PropTypes.string,
    onAdd: PropTypes.func.isRequired,
};
